import { application } from "./application"

import SearchController from "./search_controller"
import PracticeLogController from "./practice_log_controller"
import TagToggleController from "./tag_toggle_controller"
import CollapsibleController from "./collapsible_controller"
import DismissableController from "./dismissable_controller"
import TabsController from "./tabs_controller"
import TagFilterController from "./tag_filter_controller"
import BottomSheetController from "./bottom_sheet_controller"
import StudentFormController from "./student_form_controller"
import CheckboxToggleController from "./checkbox_toggle_controller"
import SortableCartController from "./sortable_cart_controller"
import SectionSelectController from "./section_select_controller"
import SidebarController from "./sidebar_controller"
import ClassFormController from "./class_form_controller"
import ScrollToErrorController from "./scroll_to_error_controller"
import ModalController from "./modal_controller"
import DropdownController from "./dropdown_controller"
import PlanBulkActionsController from "./plan_bulk_actions_controller"
import PlanServiceController from "./plan_service_controller"
import SubscriptionOptionsController from "./subscription_options_controller"
import FreePlanAlertController from "./free_plan_alert_controller"
import StudentSelectionController from "./student_selection_controller"
import ClockController from "./clock_controller"
import SurveyModalController from "./survey_modal_controller"
import LocationOverlayController from "./location_overlay_controller"
import StudentMenuController from "./student_menu_controller"
import SubscriptionWizardController from "./subscription_wizard_controller"
import JoinCheckinOverlayController from "./join_checkin_overlay_controller"
import GuestFeesController from "./guest_fees_controller"
import PasswordVisibilityController from "./password_visibility_controller"
import PhonePickerController from "./phone_picker_controller"
import PlanDeactivateModalController from "./plan_deactivate_modal_controller"
import PlanStatusController from "./plan_status_controller"
import PlanSortController from "./plan_sort_controller"
import RazorpayCheckoutController from "./razorpay_checkout_controller"
import RecordingListController from "./recording_list_controller"
import AutoSubmitController from "./auto_submit_controller"
import DisableOnSubmitController from "./disable_on_submit_controller"

application.register("search", SearchController)
application.register("practice-log", PracticeLogController)
application.register("tag-toggle", TagToggleController)
application.register("collapsible", CollapsibleController)
application.register("dismissable", DismissableController)
application.register("tabs", TabsController)
application.register("tag-filter", TagFilterController)
application.register("bottom-sheet", BottomSheetController)
application.register("student-form", StudentFormController)
application.register("checkbox-toggle", CheckboxToggleController)
application.register("sortable-cart", SortableCartController)
application.register("section-select", SectionSelectController)
application.register("sidebar", SidebarController)
application.register("class-form", ClassFormController)
application.register("scroll-to-error", ScrollToErrorController)
application.register("modal", ModalController)
application.register("dropdown", DropdownController)
application.register("plan-bulk-actions", PlanBulkActionsController)
application.register("plan-service", PlanServiceController)
application.register("subscription-options", SubscriptionOptionsController)
application.register("free-plan-alert", FreePlanAlertController)
application.register("student-selection", StudentSelectionController)
application.register("clock", ClockController)
application.register("survey-modal", SurveyModalController)
application.register("location-overlay", LocationOverlayController)
application.register("student-menu", StudentMenuController)
application.register("subscription-wizard", SubscriptionWizardController)
application.register("join-checkin-overlay", JoinCheckinOverlayController)
application.register("guest-fees", GuestFeesController)
application.register("password-visibility", PasswordVisibilityController)
application.register("phone-picker", PhonePickerController)
application.register("plan-deactivate-modal", PlanDeactivateModalController)
application.register("plan-status", PlanStatusController)
application.register("plan-sort", PlanSortController)
application.register("razorpay-checkout", RazorpayCheckoutController)
application.register("recording-list", RecordingListController)
application.register("auto-submit", AutoSubmitController)
application.register("disable-on-submit", DisableOnSubmitController)
